// src/pages/Ajustes.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

function Ajustes() {
  // Estados para la información de la empresa
  const [nombreEmpresa, setNombreEmpresa] = useState('');
  const [direccion, setDireccion] = useState('');
  const [telefono1, setTelefono1] = useState('');
  const [telefono2, setTelefono2] = useState('');
  const [correo, setCorreo] = useState('');
  const [ciudad, setCiudad] = useState('');
  const [pais, setPais] = useState('');
  const [identificacion, setIdentificacion] = useState(''); // RUC o lo que necesites
  const [descripcion, setDescripcion] = useState('');

  // 1. Al montar el componente, obtenemos los datos actuales
  useEffect(() => {
    axios
      .get('https://api.jsgraceinvestmentsllc.com/api/empresa-settings')
      .then((response) => {
        // Precargamos en los estados la data del response
        setNombreEmpresa(response.data.nombre_empresa || '');
        setDireccion(response.data.direccion || '');
        setTelefono1(response.data.telefono1 || '');
        setTelefono2(response.data.telefono2 || '');
        setCorreo(response.data.email || '');
        setCiudad(response.data.ciudad || '');
        setPais(response.data.pais || '');
        setIdentificacion(response.data.ruc || '');
        setDescripcion(response.data.descripcion || '');
      })
      .catch((error) => {
        console.error('Error al obtener empresa-settings:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar la información de la empresa.'
        });
      });
  }, []);

  // 2. Manejar el submit del formulario (POST = crear/actualizar)
  const handleSubmit = (e) => {
    e.preventDefault();

    // Construimos el objeto a enviar
    const data = {
      nombre_empresa: nombreEmpresa,
      direccion: direccion,
      telefono1: telefono1,
      telefono2: telefono2,
      email: correo,
      ciudad: ciudad,
      pais: pais,
      ruc: identificacion,
      descripcion: descripcion
    };

    // Llamada POST para crear/actualizar
    axios
      .post('http://127.0.0.1:8000/api/empresa-settings', data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        console.log('Actualizado/Creado:', response.data);
        // Alert de éxito con SweetAlert2
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: 'Los datos de la empresa se han guardado correctamente.'
        });
      })
      .catch((error) => {
        console.error('Error al guardar empresa-settings:', error);
        // Alert de error con SweetAlert2
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrió un error al guardar la información.'
        });
      });
  };

  return (
    <div className="container-xxl flex-grow-1 container-p-y">
      <h4 className="py-3">Ajustes de la Empresa</h4>

      <form onSubmit={handleSubmit}>
        <div className="row g-4">
          {/* Columna 1 */}
          <div className="col-md-6">
            <div className="card">
              <h5 className="card-header">Datos Principales</h5>
              <div className="card-body">
                {/* Nombre de la empresa */}
                <div className="mb-3">
                  <label htmlFor="nombreEmpresa" className="form-label">
                    Nombre de la empresa
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="nombreEmpresa"
                    placeholder="Ej. Mi Empresa S.A."
                    value={nombreEmpresa}
                    onChange={(e) => setNombreEmpresa(e.target.value)}
                  />
                </div>

                {/* Dirección */}
                <div className="mb-3">
                  <label htmlFor="direccion" className="form-label">
                    Dirección
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="direccion"
                    placeholder="Calle Falsa 123"
                    value={direccion}
                    onChange={(e) => setDireccion(e.target.value)}
                  />
                </div>

                {/* Teléfono 1 */}
                <div className="mb-3">
                  <label htmlFor="telefono1" className="form-label">
                    Teléfono 1
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="telefono1"
                    placeholder="0999999999"
                    value={telefono1}
                    onChange={(e) => setTelefono1(e.target.value)}
                  />
                </div>

                {/* Teléfono 2 */}
                <div className="mb-3">
                  <label htmlFor="telefono2" className="form-label">
                    Teléfono 2 (opcional)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="telefono2"
                    placeholder="022222222"
                    value={telefono2}
                    onChange={(e) => setTelefono2(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Columna 2 */}
          <div className="col-md-6">
            <div className="card">
              <h5 className="card-header">Información Adicional</h5>
              <div className="card-body">
                {/* Correo */}
                <div className="mb-3">
                  <label htmlFor="correo" className="form-label">
                    Correo electrónico
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="correo"
                    placeholder="ejemplo@empresa.com"
                    value={correo}
                    onChange={(e) => setCorreo(e.target.value)}
                  />
                </div>

                {/* Ciudad */}
                <div className="mb-3">
                  <label htmlFor="ciudad" className="form-label">
                    Ciudad
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="ciudad"
                    placeholder="Ciudad"
                    value={ciudad}
                    onChange={(e) => setCiudad(e.target.value)}
                  />
                </div>

                {/* País */}
                <div className="mb-3">
                  <label htmlFor="pais" className="form-label">
                    País
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="pais"
                    placeholder="País"
                    value={pais}
                    onChange={(e) => setPais(e.target.value)}
                  />
                </div>

                {/* Identificación (RUC) */}
                <div className="mb-3">
                  <label htmlFor="identificacion" className="form-label">
                    RUC / Identificación
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="identificacion"
                    placeholder="1234567890001"
                    value={identificacion}
                    onChange={(e) => setIdentificacion(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Tercera fila con descripción */}
          <div className="col-md-12">
            <div className="card">
              <h5 className="card-header">Descripción</h5>
              <div className="card-body">
                <div className="mb-3">
                  <label htmlFor="descripcion" className="form-label">
                    Descripción de la empresa
                  </label>
                  <textarea
                    className="form-control"
                    id="descripcion"
                    rows="3"
                    placeholder="Información adicional, reseña de la empresa..."
                    value={descripcion}
                    onChange={(e) => setDescripcion(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Botón de Guardar */}
        <div className="mt-4 d-flex justify-content-end">
          <button type="submit" className="btn btn-primary">
            Guardar
          </button>
        </div>
      </form>
    </div>
  );
}

export default Ajustes;
